import React from 'react';
import { Page, Content, Progress } from '@backstage/core-components';
import { Grid } from '@material-ui/core';
import { useDeploymentLocks } from '../../hooks/useDeploymentLocks';
import { DeploymentCard } from '../DeploymentCard/DeploymentCard';
import {
  createNYPDeployment,
  createSunDeployment,
} from '../../data/deploymentData';
import { useGithubApi } from '../../hooks/useGithubApi';
import useAsync from 'react-use/lib/useAsync';
import Alert from '@material-ui/lab/Alert';

export const DeploymentDashboard = () => {
  const fetchGithubApi = useGithubApi();
  const { toggleLock, isLocked } = useDeploymentLocks({
    nyp: true,
    sun: false,
  });

  const {
    value: repo,
    loading,
    error: githubError,
  } = useAsync(async () => {
    return fetchGithubApi();
  }, []);

  const nypProps = createNYPDeployment(isLocked('nyp'), () =>
    toggleLock('nyp'),
  );

  const sunProps = createSunDeployment(isLocked('sun'), () =>
    toggleLock('sun'),
  );

  if (loading) {
    return <Progress />;
  }

  if (githubError) {
    return <Alert severity="error">{githubError.message}</Alert>;
  }

  return (
    <Page themeId="tool">
      <Content>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <DeploymentCard {...nypProps} {...repo} />
          </Grid>
          <Grid item xs={12} lg={6}>
            <DeploymentCard {...sunProps} />
          </Grid>
        </Grid>
      </Content>
    </Page>
  );
};
